import { firestore } from "@foresting-tomorrow/api_types_firestore";

// --- Types --- //
export type RawWoodOptionProps = {
  id: string;
  label: string;
  adjustment?: number;
};

// --- Assortment options --- //
export const ASSORTMENT_OPTIONS: string[] = [
  "shortTimber",
  "ktoMix",
  "energyWood",
  "packagingWood",
  "troldhedeClass1",
  "troldhedeClass2",
  "pulpwoodMix",
  "export",
];

export const LOG_CLASS_OPTIONS: string[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
];

export const LOG_CLASS_EXPORT_OPTIONS: string[] = [
  "veneer",
  "sPlus",
  "s",
  "p",
  "f",
  "w"
];

// --- Stack options --- //
export const STACKING_OPTIONS: RawWoodOptionProps[] = [
  {
    id: "manualGood",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-hand-good",
    adjustment: 0,
  },
  {
    id: "machineExceptionel",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-excellent",
    adjustment: -1,
  },
  {
    id: "machineGood",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-good",
    adjustment: -2,
  },
  {
    id: "machineNormal",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-normal",
    adjustment: -3,
  },
  {
    id: "machineBad1",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-poor",
    adjustment: -4,
  },
  {
    id: "machineBad2",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-poor",
    adjustment: -5,
  },
  {
    id: "machineVeryBad1",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-very-poor",
    adjustment: -6,
  },
  {
    id: "machineVeryBad2",
    label: "input-dialog-raw-wood-input-conversion-factor-stacking-machine-very-poor",
    adjustment: -7,
  },
];
export const STRAIGHTNESS_OPTIONS: RawWoodOptionProps[] = [
  {
    id: "straight",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-straight",
    adjustment: 0,
  },
  {
    id: "slightlyCurved",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-slightly-bent",
    adjustment: -1,
  },
  {
    id: "curved",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-bent",
    adjustment: -2,
  },
  {
    id: "veryCurved1",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-strongly-bent",
    adjustment: -3,
  },
  {
    id: "veryCurved2",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-strongly-bent",
    adjustment: -4,
  },
  {
    id: "extremelyCurved1",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-very-strongly-bent",
    adjustment: -5,
  },
  {
    id: "extremelyCurved2",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-very-strongly-bent",
    adjustment: -6,
  },
  {
    id: "bent1",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-extremely-bent",
    adjustment: -7,
  },
  {
    id: "bent2",
    label: "input-dialog-raw-wood-input-conversion-factor-straightness-extremely-bent",
    adjustment: -8,
  },
];
export const PROCESSING_OPTIONS: RawWoodOptionProps[] = [
  {
    id: "exceptional",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-plan-trimmed",
    adjustment: 0,
  },
  {
    id: "good",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-few-stumps",
    adjustment: -1,
  },
  {
    id: "normal1",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-many-knots",
    adjustment: -2,
  },
  {
    id: "normal2",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-many-knots",
    adjustment: -3,
  },
  {
    id: "bad1",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-partly-rough",
    adjustment: -4,
  },
  {
    id: "bad2",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-partly-rough",
    adjustment: -5,
  },
  {
    id: "veryBad1",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-rough-or-very-poor",
    adjustment: -6,
  },
  {
    id: "veryBad2",
    label: "input-dialog-raw-wood-input-conversion-factor-processing-rough-or-very-poor",
    adjustment: -7,
  },
];
export const SNOW_ICE_OPTIONS: RawWoodOptionProps[] = [
  {
    id: "none",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-none",
    adjustment: 0,
  },
  {
    id: "moderate1",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-minor",
    adjustment: -1,
  },
  {
    id: "moderate2",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-minor",
    adjustment: -2,
  },
  {
    id: "heavy1",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-major",
    adjustment: -3,
  },
  {
    id: "heavy2",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-major",
    adjustment: -4,
  },
  {
    id: "heavy3",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-major",
    adjustment: -5,
  },
  {
    id: "heavy4",
    label: "input-dialog-raw-wood-input-conversion-factor-snow-ice-major",
    adjustment: -6,
  },
];
export const RESIDUES_OPTIONS: RawWoodOptionProps[] = [
  {
    id: "none",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-none",
    adjustment: 0,
  },
  {
    id: "light",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-minor",
    adjustment: -1,
  },
  {
    id: "moderate",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-major",
    adjustment: -2,
  },
  {
    id: "heavy",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-high",
    adjustment: -3,
  },
  {
    id: "extreme1",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-extreme",
    adjustment: -4,
  },
  {
    id: "extreme2",
    label: "input-dialog-raw-wood-input-conversion-factor-residues-extreme",
    adjustment: -5,
  },
];
export const REJECTS_OPTIONS = Array.from({ length: 100 }, (_, i) => {
  const number = i.toString();
  return {
    id: number,
    label: number,
  };
});
export const BATTENS_OPTIONS = Array.from({ length: 100 }, (_, i) => {
  const number = i.toString();
  return {
    id: number,
    label: number,
  };
});

export const STATUS_OPTIONS: string[] = ["forwarded", "measured", "sold", "collected"];

export const ACCESSIBILITY_OPTIONS: string[] = [
  "pavedRoad",
  "steelPlateRoad",
  "dirtRoad",
  "lockCode",
];

export const BUYER_APPROVAL_OPTIONS = firestore.inventoryBuyerApprovalStatus.options;

export const WOOD_CHIP_SPECIES_OPTIONS: string[] = ["foliage", "needle", "mixed"];

export const WOOD_LOG_ASSORTMENT_OPTIONS: string[] = [
  "sawlogs",
  "exportSawlogs",
  "longLogs"
];
